import { API_BASE_PATH } from "@/const/default-values"
import { RESOURCES_NAMES } from "@/const/resource.constants"

// Signs in with a password the API checks (a tenant on the Kodem auth backend, or self-hosted). The
// session lives in the API cookies. Resolves to null when the credentials are rejected
export const signInWithKodemPassword = async (
  slug: string,
  email: string,
  password: string
): Promise<{ email: string } | null> => {
  // A same-origin call from the browser, not a server-side request
  // nosemgrep: rules_lgpl_javascript_ssrf_rule-node-ssrf
  const response = await fetch(
    `${API_BASE_PATH}${RESOURCES_NAMES.AUTHENTICATION.LOGIN}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ slug, userEmail: email, password })
    }
  )

  if (response.status === 401) return null

  if (!response.ok)
    throw new Error(`Password sign-in failed with status ${response.status}`)

  const { data } = await response.json()

  return { email: data?.email || email }
}

// Exchanges the handoff token of a Kodem SSO login for the API session cookies. Resolves to the
// signed-in email
export const exchangeKodemSsoToken = async (
  slug: string,
  ssoToken: string
): Promise<string | null> => {
  // A same-origin call from the browser, not a server-side request
  // nosemgrep: rules_lgpl_javascript_ssrf_rule-node-ssrf
  const response = await fetch(
    `${API_BASE_PATH}${RESOURCES_NAMES.AUTHENTICATION.AUTH}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ slug, ssoToken })
    }
  )

  if (!response.ok)
    throw new Error(`SSO token exchange failed with status ${response.status}`)

  const { data } = await response.json()

  return data?.email ?? null
}
